/**
 * @file     index.ts
 * @purpose  Barrel re-export for all app-level constants: analytics event names, lead flow routes, navigation taxonomy, and route paths.
 */
export * from './analytics';
export * from './leadFlowRoutes';
export * from './navigation';
export * from './routes';
